import React from 'react';
import { X } from 'lucide-react';
import CookieCategoryItem from './CookieCategoryItem';

export const tr = (cookies, key, fallback) => cookies?.[key] || fallback;

export const CookieModalHeader = ({ cookies, onClose }) => (
  <div className="sticky top-0 bg-white border-b border-gray-200 p-6 rounded-t-2xl z-10">
    <div className="flex items-start justify-between">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          {tr(cookies, 'title', 'Customise Consent Preferences')}
        </h2>
        <p className="text-gray-600 text-sm">
          {tr(cookies, 'subtitle', 'We use cookies to help you navigate efficiently.')}
        </p>
      </div>
      <button onClick={onClose} data-testid="cookie-modal-close-btn" className="p-2 hover:bg-gray-100 rounded-lg transition-colors">
        <X className="w-5 h-5 text-gray-500" />
      </button>
    </div>
  </div>
);

const FOOTER_BUTTONS = [
  { key: 'rejectAll', fallback: 'Reject All', handler: 'onRejectAll', className: 'bg-white border-2 border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors' },
  { key: 'savePreferences', fallback: 'Save Preferences', handler: 'onSavePreferences', className: 'bg-white border-2 border-blue-500 text-blue-600 hover:bg-blue-50 transition-colors' },
  { key: 'acceptAll', fallback: 'Accept All', handler: 'onAcceptAll', className: 'bg-gradient-to-r from-blue-500 to-blue-600 text-white hover:from-blue-600 hover:to-blue-700 transition-colors shadow-lg' },
];

export const CookieModalFooter = ({ cookies, ...handlers }) => (
  <div className="sticky bottom-0 bg-white border-t border-gray-200 p-6 rounded-b-2xl">
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
      {FOOTER_BUTTONS.map((btn) => (
        <button
          key={btn.key}
          onClick={handlers[btn.handler]}
          data-testid={`cookie-modal-${btn.key}-btn`}
          className={`px-6 py-3 rounded-lg font-medium ${btn.className}`}
        >
          {tr(cookies, btn.key, btn.fallback)}
        </button>
      ))}
    </div>
  </div>
);

export const CookieModalBody = ({ cookies, categories, preferences, onToggle, showDetails, onToggleDetails }) => (
  <div className="p-6 space-y-6">
    <div className="prose prose-sm max-w-none">
      <p className="text-gray-700">{tr(cookies, 'description', 'You will find detailed information about all cookies.')}</p>
      <p className="text-gray-700">
        {tr(cookies, 'necessaryInfo', 'Necessary cookies are essential.')}{' '}
        <button onClick={onToggleDetails} data-testid="cookie-modal-details-toggle" className="text-blue-600 hover:underline font-medium">
          {showDetails ? tr(cookies, 'showLess', 'Show less') : tr(cookies, 'showMore', 'Show more')}
        </button>
      </p>
    </div>
    <div className="space-y-4">
      {categories.map((category) => (
        <CookieCategoryItem
          key={category.id}
          category={category}
          isActive={preferences[category.id]}
          onToggle={onToggle}
          showDetails={showDetails}
        />
      ))}
    </div>
  </div>
);
